import { isAuthorized, lazyLoadView, piloteAndAuditor } from '@/router/routing'
import type { Route, RouteConfig } from 'vue-router'
import { passThroughComponent } from '@/plugins/pass-through-component'
import { SECURITY_BASE_ROUTE_NAMES } from '@/contexts/security-base/SecurityBase.constants'

const securityBaseMeasuresDifferencesRouting: RouteConfig = {
  path: 'differences',
  name: SECURITY_BASE_ROUTE_NAMES.MEASURES_DIFFERENCES,
  component: () => lazyLoadView(import('@/contexts/security-base/SecurityBaseMeasuresDiffView.vue')),
  meta: {
    i18nTitle: 'security_base.menu.differences',
    is_authorized: (route: Route) => isAuthorized(route),
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'security_bases_measures_differences',
  },
}

const securityBaseMeasuresRouting: RouteConfig = {
  path: ':perimeterId/measures',
  component: {
    render: passThroughComponent,
  },
  children: [
    {
      path: '',
      name: SECURITY_BASE_ROUTE_NAMES.MEASURES,
      component: () => lazyLoadView(import('@/contexts/security-base/SecurityBaseMeasuresView.vue')),
      meta: {
        hide_in_breadcrumb: true,
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'security_bases_measures',
      },
    },
    securityBaseMeasuresDifferencesRouting,
  ],
}

const securityBasePerimetersRouting: RouteConfig = {
  path: 'perimeters',
  component: {
    render: passThroughComponent,
  },
  children: [
    {
      path: '',
      name: SECURITY_BASE_ROUTE_NAMES.PERIMETERS,
      component: () => lazyLoadView(import('@/contexts/security-base/SecurityBasePerimetersView.vue')),
      meta: {
        hide_in_breadcrumb: true,
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'security_bases_perimeters',
      },
    },
    securityBaseMeasuresRouting,
  ],
}

export const securityBaseRouting: RouteConfig = {
  path: '/security-bases',
  component: {
    render: passThroughComponent,
  },
  meta: {
    i18nTitle: 'security_base.menu.title',
    icon: 'shield-check',
    is_authorized: (route: Route) => {
      return isAuthorized(route)
    },
    requires_auth: true,
    requires_tenant: true,
    requires_role: piloteAndAuditor,
    doc_id: 'security_bases',
    feature_id: 'SECURITY_BASE',
  },
  children: [
    {
      path: '',
      name: SECURITY_BASE_ROUTE_NAMES.POLICIES,
      component: () => lazyLoadView(import('@/contexts/security-base/SecurityBasePoliciesView.vue')),
      meta: {
        is_authorized: (route: Route) => isAuthorized(route),
        requires_auth: true,
        requires_tenant: true,
        requires_role: piloteAndAuditor,
        doc_id: 'security_bases_policies',
      },
    },
    securityBasePerimetersRouting,
  ],
}
